export const countUpTimer = (() => {
  let startTime;

  return {
    init: () => (startTime = Math.floor(Date.now() / 1000)),
    isInitialized () {
      return  startTime !== undefined
    },
    checkTime ()  {
    if(!startTime) {console.log("timer not initialized before calling checktime"); return };
      var now = Math.floor(Date.now() / 1000); // get the time now
      var diff = now - startTime; // diff in seconds between now and start
      var m = Math.floor(diff / 60); // get minutes value (quotient of diff)
      var s = Math.floor(diff % 60); // get seconds value (remainder of diff)
      m = this.parseTime(m); // add a leading zero if it's single digit
      s = this.parseTime(s); // add a leading zero if it's single digit
      return m + ":" + s; // update the element where the timer will appear
      // var t = setTimeout(startTimeCounter, 100); // set a timeout to update the timer
    },
    parseTime: (i) => {
      if (i < 10) {
        i = "0" + i;
      } // add zero in front of numbers < 10
      return i;
    },
  };
})();

window.countUpTimer = countUpTimer